var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.loading)?_c('loader'):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[(_vm.complete)?_c('verification-complete'):_vm._e(),_vm._v(" "),(_vm.failed)?_c('verification-failed'):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }